import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const PlayerPopoverContainer = styled.div`
    pointer-events: none;
    position: absolute;
    display: flex;
    bottom: 12px;
    left: -60px;
    width: 148px;
    height: 175px;
    z-index: 1;

    ${BaseStyle.Mixins.screenSizes.small} {
        width: 116px;
        height: 132px;
        bottom: 34px;
        left: -46px;
    }
`;

export const PopoverContentContainer = styled.div`
    text-align: center;
    position: absolute;
    width: 100%;
    top: 4%;

    ${BaseStyle.Mixins.screenSizes.small} {
        top: 15%;
    }
`;
export const HeadshotContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 8px;

    ${BaseStyle.Mixins.screenSizes.small} {
        margin: 3px;
    }
`;

export const PlayerName = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12b']};
    margin-top: 2px;
    margin-bottom: 6px;

    ${BaseStyle.Mixins.screenSizes.small} {
        ${BaseStyle.Mixins.fontStyles.ui['10b']};
    }
`;

export const PopoverInfo = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['12m']};
    margin-top: 4px;
    margin-bottom: 2px;

    ${BaseStyle.Mixins.screenSizes.small} {
        ${BaseStyle.Mixins.fontStyles.ui['10m']};
        margin-top: 2px;
    }
`;

export const TimeCategoryText = styled.span`
    ${BaseStyle.Mixins.fontStyles.ui['12m']};
    color: ${({ theme }) => theme.Text.secondary};

    ${BaseStyle.Mixins.screenSizes.small} {
        ${BaseStyle.Mixins.fontStyles.ui['10m']};
    }
`;

export const GreyDot = styled.span`
    color: ${({ theme }) => theme.Text.disabled};
`;

export const TimeLeft = styled.span`
    ${BaseStyle.Mixins.fontStyles.ui['12b']};

    ${BaseStyle.Mixins.screenSizes.small} {
        ${BaseStyle.Mixins.fontStyles.ui['10b']};
    }
`;
